<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchAll"
                append-icon="search"
                label="Búsqueda"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="6"> </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarBusqueda"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarBusquedas ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarBusquedas
                ? "Ocultar filtros de búsqueda"
                : "Mostrar filtros de búsqueda"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarInactivos"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ inactivos ? "visibility_off" : "visibility" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              inactivos ? "Ocultar Inactivos" : "Mostrar Inactivos"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> sim_card_download </v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="agregar"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
        </v-app-bar>

        <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 128 : 200)"
            :headers="headers"
            :items="dtUsuarios"
            :hide-default-header="isMobile"
            mobile-breakpoint="0"
            sort-by="codigo"
            :search="searchAll"
            class="elevation-1"
            :loading="dtUsuariosLoad"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    text
                    dark
                    color="primary"
                    @click="editar(item)"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    fab
                  >
                    <v-icon dark> edit </v-icon>
                  </v-btn>
                </template>
                <span>Editar usuario</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    text
                    dark
                    color="primary"
                    @click="asignarTalonario(item)"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    fab
                  >
                    <v-icon dark>fa-solid fa-file-invoice-dollar</v-icon>
                  </v-btn>
                </template>
                <span>Asignar Talonario</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.tipo_documento`]="{ item }">
              <div>
                {{ recorrerResultadoJson(item.tipo_documento) }}

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      text
                      dark
                      color="primary"
                      @click="asignarTipoDocumento(item)"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      fab
                    >
                      <v-icon dark> edit </v-icon>
                    </v-btn>
                  </template>
                  <span>Asignar Tipo de Documento</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:[`item.area`]="{ item }">
              <div>
                {{ recorrerResultadoJson(item.area) }}

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      text
                      dark
                      color="primary"
                      @click="asignarArea(item)"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      fab
                    >
                      <v-icon dark> edit </v-icon>
                    </v-btn>
                  </template>
                  <span>Asignar área</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:[`item.ultimo_ingreso`]="{ item }">
              <div>
                {{ formatoFechaHoras(item.ultimo_ingreso) }}
              </div>
            </template>

            

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'I'">
                <v-btn
                  color="error"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:no-data>
              <div>No se encontraron registros</div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogBeta"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="guardar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> save </v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="usuario"
                    v-model="usuario"
                    :readonly="!editarCodigo"
                    :rules="[$rules.requerido, $rules.max50]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Usuario"
                    required
                  ></v-text-field>

                  <v-autocomplete
                    outlined
                    dense
                    ref="id_rol"
                    v-model="id_rol"
                    :items="rolList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Rol"
                    required
                  ></v-autocomplete>
                  <v-text-field
                    outlined
                    dense
                    ref="codigo_sac"
                    v-model="codigo_sac"
                    
                    :rules="[]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Codigo SAC"
                    required
                  ></v-text-field>
                  <v-autocomplete
                    outlined
                    dense
                    ref="sucursal"
                    v-model="sucursal"
                    :items="sucursalList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Sucursal"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog dense v-model="dialogGamma" persistent max-width="500px">
        <v-card ref="formGamma">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga de Plantillas</span>
            </v-card-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="dialogGamma = false"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    dense
                    v-model="file"
                    id="file"
                    ref="file"
                    @change="archivoCambiado"
                    show-size
                    chips
                    accept="*"
                    placeholder="Seleccione una nueva plantilla"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="cargarArchivo"
                  color="success"
                  :loading="load"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar Archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSigma"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-card class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-row v-if="mostrarBusquedas">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchAll"
                  append-icon="search"
                  label="Búsqueda"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="6" md="6"> </v-col>
            </v-row>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="guardarTipoDocumento"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> save </v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarTipoDocumento"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
            <v-data-table
              dense
              fixed-header
              :height="windowHeigth - (isMobile ? 128 : 200)"
              :headers="headersTipoDocumento"
              v-model="checkTipoDocumento"
              :items="dtTipoDocumentos"
              item-key="id"
              show-select
              :hide-default-header="isMobile"
              mobile-breakpoint="0"
              :search="searchAll"
              class="elevation-1"
              :loading="dtTipoDocumentosLoad"
              loading-text="Cargando... Espere por favor"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [-1, 100, 150, 200],
              }"
            >
              

              <template v-slot:[`item.estado`]="{ item }">
                <div v-if="item.estado == 'I'">
                  <v-btn
                    color="error"
                    x-small
                    text
                    dark
                    @click="abrirDialogActivacion(item)"
                  >
                    <v-icon x-small>block</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn
                    color="success"
                    x-small
                    text
                    dark
                    @click="abrirDialogActivacion(item)"
                  >
                    <v-icon x-small>check</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:no-data>
                <div>No se encontraron registros</div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogLambda"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-card class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-row v-if="mostrarBusquedas">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchAll"
                  append-icon="search"
                  label="Búsqueda"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="6" md="6"> </v-col>
            </v-row>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="guardarArea"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> save </v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarArea"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
            <v-data-table
              dense
              fixed-header
              :height="windowHeigth - (isMobile ? 128 : 200)"
              :headers="headersArea"
              v-model="checkArea"
              :items="dtAreas"
              item-key="id"
              show-select
              :hide-default-header="isMobile"
              mobile-breakpoint="0"
              :search="searchAll"
              class="elevation-1"
              :loading="dtAreasLoad"
              loading-text="Cargando... Espere por favor"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [-1, 100, 150, 200],
              }"
            >
              

              <template v-slot:[`item.estado`]="{ item }">
                <div v-if="item.estado == 'I'">
                  <v-btn
                    color="error"
                    x-small
                    text
                    dark
                    @click="abrirDialogActivacion(item)"
                  >
                    <v-icon x-small>block</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn
                    color="success"
                    x-small
                    text
                    dark
                    @click="abrirDialogActivacion(item)"
                  >
                    <v-icon x-small>check</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:no-data>
                <div>No se encontraron registros</div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogTau"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-card class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll flat>
            
            <v-row >
              <v-col cols="12" sm="6" md="6"> Asignación de Talonario</v-col>
            </v-row>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarTalonario"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver</span>
            </v-tooltip>
          </v-app-bar>

          <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
            <v-data-table
              dense
              fixed-header
              :height="windowHeigth - (isMobile ? 128 : 200)"
              :headers="headersTalonario"
              v-model="checkArea"
              :items="dtTalonario"
              :hide-default-header="isMobile"
              mobile-breakpoint="0"
              
              class="elevation-1"
              :loading="dtTalonarioLoad"
              loading-text="Cargando... Espere por favor"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [-1, 100, 150, 200],
              }"
            >
              
              <template v-slot:[`item.estado`]="{ item }">
                <div v-if="item.estado == 'A'">
                  <v-btn
                    color="success"
                    x-small
                    text
                    dark
                    @click="remover(item)"
                  >
                    <v-icon x-small>check</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn color="error" x-small text dark @click="asignar(item)">
                    <v-icon x-small>block</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:no-data>
                <div>No se encontraron registros</div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      //Declaración de variables globales
      user: this.$store.state.usuario.user,
      //Declaración de arrays
      dtUsuarios: [],
      dtUsuariosLoad: true,
      dtTipoDocumentos: [],
      dtTipoDocumentosLoad: true,
      dtAreas: [],
      dtAreasLoad: true,
      dtTalonario: [],
      dtTalonarioLoad: true,
      dtPlantilla: [],
      areaList: [],
      subareaList: [],
      rolList: [],
      checkTipoDocumento: [],
      checkArea: [],
      sucursalList: [],

     
      //Declaración de variables de Dialog
      dialogBeta: false,
      dialogCargaExcel: false,
      dialogAlpha: false,
      dialogGamma: false,
      dialogSigma: false,

      //Declaración de variables de formulario
      id: "",
      codigo: "",
      descripcion: "",
      usuario: "",
      id_rol: "",
      codigo_sac: "",
      estado: "",
      sucursal: "",
      porcentajeCco: "",
      porcentaje: 100,
      id_centro_costo: "",

      file: null,
      nombreArchivo: "",
      rutaArchivo: "",
      fechaArchivo: "",
      load: false,
      icono: "",
      color: "",
      //Declaración de variables de tabla

      selected: [2],

      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "1%",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Usuario",
          value: "usuario",
          align: "left",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Rol",
          value: "rol",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Sucursal",
          value: "sucursal",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        
        {
          text: "Último ingreso",
          value: "ultimo_ingreso",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Activo",
          sortable: false,
          value: "estado",
          width: "1%",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],
     

      headersTipoDocumento: [
        {
          text: "Tipo de documento",
          value: "descripcion",
          align: "left",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],
      headersArea: [
        {
          text: "Área",
          value: "descripcion",
          align: "left",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],

      headersTalonario: [
        {
          text: "Nombre",
          value: "talonario",
          align: "left",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Asignado",
          sortable: false,
          value: "estado",
          width: "1%",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],

      headersPlantilla: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha de Subida",
          value: "insertdate",
          class: "primary white--text text-subtitle-2",
        },
      ],
      searchAll: "",
      esEditado: false,
      editarCodigo: false,

      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      mostrarBusquedas: false,
      //variables de errrores
      valida: 0,
      errorMessages: "",

      error: "",
      //variables de tamaño de pantalla
      isMobile: false,

      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        usuario: this.usuario,
        id_rol: this.id_rol,
        codigo_sac: this.codigo_sac,
      };
    },
  },

  watch: {
    dialogBeta(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
    },
  },
  mounted() {
     this.getDimensions();
  },
  

  created() {
    this.$store.dispatch("actualizarTitulo", "Usuarios");
    this.selectSucursal();
    this.listar();
    this.selectRoles();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },
    cargarArchivo() {
      let me = this;

      const formData = new FormData();
      formData.append("id", this.id);
      formData.append("codigo", this.codigo);
      formData.append("descripcion", this.descripcion);

      formData.append("usuario", this.user);

      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        formData.append(null, null);
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      axios
        .put("api/usuarios/cargarArchivo", formData)
        .then(function (response) {
          me.nombreArchivo = me.selectedFile.name;
          me.configurarIcono();
          me.file = null;
          me.selectedFile = null;
          me.listar();
          me.dialogGamma = false;
          me.$store.dispatch("setSnackbar", {
            text: " Adjunto subido exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtUsuariosLoad = true;
      axios
        .get("api/usuarios/listar")
        .then(function (response) {
          me.dtUsuarios = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtUsuariosLoad = false;
        })
        .catch(function (error) {
          me.dtUsuariosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    selectSucursal() {
      let me = this;
      me.dtUsuariosLoad = true;
      axios
        .get("api/clientes/SelectSucursal")
        .then(function (response) {
          me.sucursalList = response.data;          
        })
        .catch(function (error) {
          me.dtUsuariosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarTipoDocumento() {
      let me = this;
      me.dtTipoDocumentosLoad = true;
      axios
        .get("api/tipo_documentos/select")
        .then(function (response) {
          me.dtTipoDocumentos = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtTipoDocumentosLoad = false;
        })
        .catch(function (error) {
          me.dtTipoDocumentosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    listarArea() {
      let me = this;
      me.dtAreasLoad = true;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.dtAreas = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtAreasLoad = false;
        })
        .catch(function (error) {
          me.dtAreasLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarTalonario() {
      let me = this;
      me.dtTalonarioLoad = true;
      axios
        .get("api/usuario_talonarios/listarTalonarios/" + me.id)
        .then(function (response) {
          me.dtTalonario = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtTalonarioLoad = false;
        })
        .catch(function (error) {
          me.dtTalonarioLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarDocumentoCentro() {
      let me = this;
      axios
        .get("api/documento_centros/listarDocumentoCentro/" + this.id)
        .then(function (response) {
          me.mostrarPorcentaje();
          me.dtPlantilla = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    mostrarPorcentaje() {
      let me = this;
      axios
        .get("api/documento_centros/mostarPorcentaje/" + this.id)
        .then(function (response) {
          me.porcentajeCco = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogAlpha = true;
      this.estado = item.estado;
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },

    editar(item) {
      this.id = item.id;
      this.usuario = item.usuario;
      this.id_rol = item.id_rol;
      this.codigo_sac = item.codigo_sac;
      this.sucursal = item.sucursal;

      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogBeta = true;

      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada
    },
    agregar() {
      this.editarCodigo = true;
      this.dialogBeta = true;
    },
    agregarPlantilla() {
      this.dialogGamma = true;
    },
    asignarTipoDocumento(item) {
      this.listarTipoDocumento();
      this.dialogSigma = true;
      this.id = item.id;
      this.checkTipoDocumento =
        item.tipo_documento === null || item.tipo_documento === ""
          ? JSON.parse("[]")
          : JSON.parse(item.tipo_documento);
    },
    asignarArea(item) {
      this.listarArea();
      this.dialogLambda = true;
      this.id = item.id;
      this.checkArea =
        item.area === null || item.area === "" || item.area === undefined
          ? JSON.parse("[]")
          : JSON.parse(item.area);
    },
    asignarTalonario(item) {
      this.dialogTau = true;
      this.id = item.id;
      this.listarTalonario();
      //this.checkArea= item.area=== null || item.area==="" || item.area===undefined ? JSON.parse("[]") : JSON.parse(item.area);
    },

    cerrar() {
      this.dialogBeta = false;
      this.limpiar();
    },
    cerrarTipoDocumento() {
      this.dialogSigma = false;
      this.checkTipoDocumento = [];
    },
    cerrarArea() {
      this.dialogLambda = false;
      this.checkArea = [];
    },
    cerrarTalonario() {
      this.dialogTau = false;
      //this.checkArea = [];
    },

    limpiar() {
      this.id = "";
      this.usuario = "";
      this.id_rol = "";
      this.codigo_sac = "";
      

      this.nombreArchivo = "";
      this.rutaArchivo = "";
      this.fechaArchivo = "";
      this.esEditado = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    selectRoles() {
      let me = this;
      axios
        .get("api/roles/select")
        .then(function (response) {
          me.rolList = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/usuarios/actualizar", {
            id: me.id,
            usuario: me.usuario,
            id_rol: me.id_rol,
            codigo_sac: me.codigo_sac,
            sucursal: me.sucursal,

            user: me.user,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/usuarios/crear", {
            usuario: me.usuario,
            id_rol: me.id_rol,
            codigo_sac: me.codigo_sac,
            sucursal: me.sucursal,

            user: me.usuario,
          })
          .then(function (response) {
            me.esEditado = true;
            me.id = response.data;
            me.listar();
            me.limpiar();
            me.cerrar();
            me.$store.dispatch("setSnackbar", {
              text: " Usuario creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarTipoDocumento() {
      //codigo para guardar
      let me = this;

      axios
        .post("api/usuarios/ActualizarTipoDoc", {
          id: me.id,
          tipo_documento: me.checkTipoDocumento,
          user: me.user,
        })
        .then(function (response) {
          me.cerrarTipoDocumento();
          me.listar();
          me.checkTipoDocumento = [];

          me.$store.dispatch("setSnackbar", {
            text: "Asignación de tipo de documentos realizada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    guardarArea() {
      //codigo para guardar
      let me = this;

      axios
        .post("api/usuarios/ActualizarArea", {
          id: me.id,
          area: me.checkArea,
          user: me.user,
        })
        .then(function (response) {
          me.cerrarArea();
          me.listar();
          me.checkArea = [];

          me.$store.dispatch("setSnackbar", {
            text: "Asignación de áreas realizada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    guardarTalonario() {
      //codigo para guardar
      let me = this;

      axios
        .post("api/usuario_talonarios/ActualizarArea", {
          id: me.id,
          area: me.checkArea,
          user: me.user,
        })
        .then(function (response) {
          me.cerrarArea();
          me.listar();
          me.checkArea = [];

          me.$store.dispatch("setSnackbar", {
            text: "Asignación de áreas realizada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    asignar(item) {
      let me = this;
      axios
        .post("api/usuario_talonarios/crear", {
          id_usuario: me.id,
          id_talonario: item.id_talonario,
          usuario: me.user,
        })
        .then(function (response) {
          me.listarTalonario();

          me.$store.dispatch("setSnackbar", {
            text: "Registro creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    remover(item) {
      let me = this;

      axios
        .put(
          "api/usuario_talonarios/EliminarTalonario/" +
            me.id +
            "/" +
            item.id_talonario +
            "/" +
            me.user,
          {}
        )
        .then(function (response) {
          me.listarTalonario();
          me.$store.dispatch("setSnackbar", {
            text: "Subarea removida exitosamente.",
            color: "success",
          });
          me.dialogBorrarSubarea = false;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    exportarExcel() {
      let me = this;
      axios
        .get("api/usuarios/exportarExcel")
        .then(function (response) {
          me.downloadExcel(response.data);
        })
        .catch(function (error) {
          console.error(error);
        })
        .then(function () {
          me.listar();
        });
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/usuarios/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.cerrarCarga();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar() {
      let me = this;
      axios
        .put("api/usuarios/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/usuarios/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    download(link, title) {
      var element = document.createElement("a");
      element.setAttribute("href", link);
      element.setAttribute("download", title);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    configurarIcono() {
      let me = this;
      me.icono = me.getIconClass(me.nombreArchivo);
      me.color = me.getFileColor(me.nombreArchivo);
    },
    //get the extension of file name
    getExtension(filename) {
      if (filename == null) {
        return "";
      }
      var parts = filename.split(".");
      return parts[parts.length - 1];
    },

    //return color of file extension
    getFileColor(filename) {
      var ext = this.getExtension(filename);
      switch (ext) {
        case "pdf":
          return "red";
        case "doc":
        case "docx":
          return "blue";
        case "xls":
        case "xlsx":
          return "green";
        case "ppt":
        case "pptx":
          return "orange";
        case "zip":
        case "rar":
          return "grey";
        case "txt":
          return "brown";
        case "png":
        case "jpg":
        case "jpeg":
          return "purple";
        default:
          return "grey";
      }
    },

    //return icon class based on file extension
    getIconClass(filename) {
      var ext = this.getExtension(filename);
      switch (ext.toLowerCase()) {
        case "doc":
        case "docx":
          return "fa-solid fa-file-word";
        case "xls":
        case "xlsx":
          return "fa-solid fa-file-excel";
        case "ppt":
        case "pptx":
          return "fa-solid fa-file-powerpoint";
        case "pdf":
          return "fa-solid fa-file-pdf";
        case "zip":
        case "rar":
          return "fa-solid fa-file-archive";
        case "txt":
          return "fa-solid fa-file-text";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "fa-solid fa-file-image";
        case "mp3":
        case "wav":
          return "fa-solid fa-file-audio";
        case "mp4":
        case "avi":
        case "wmv":
        case "flv":
        case "mov":
        case "3gp":
          return "fa-solid fa-file-video";
        default:
          return "fa-solid fa-file";
      }
    },
    //format datetime to dd/mm/yyyy hh:mm:ss
    formatoFechaHoras(date) {
      if (date == null) {
        return "";
      }
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (hour < 10) hour = "0" + hour;
      if (minute < 10) minute = "0" + minute;
      if (second < 10) second = "0" + second;

      return (
        [day, month, year].join("/") + " " + hour + ":" + minute + ":" + second
      );
    },

    //recorrer json y devolver un string con los valores
    recorrerResultadoJson(j) {
      var json = j == null || j == "" || j == undefined ? "" : JSON.parse(j);
      var largo = json === "" ? 0 : json.length;
      var cadena = "";
      for (var i = 0; i < largo; i++) {
        cadena += json[i].descripcion;
        if (i < largo - 1) {
          cadena += ", ";
        }
      }
      return cadena;
    },
    //eliminar propiedad de arreglo json
    eliminarPropiedadJson(json, propiedad) {
      var resultado = [];
      json.forEach(function (value) {
        var objeto = {};
        for (var prop in value) {
          if (prop != propiedad) {
            objeto[prop] = value[prop];
          }
        }
        resultado.push(objeto);
      });
      return resultado;
    },

    //convertir json a array
    convertirJsonArray(json) {
      var resultado = [];
      json.forEach(function (value) {
        var objeto = {};
        for (var prop in value) {
          objeto[prop] = value[prop];
        }
        resultado.push(objeto);
      });
      return resultado;
    },

    //convertir array a json
    convertirArrayJson(array) {
      var resultado = [];
      array.forEach(function (value) {
        var objeto = {};
        for (var prop in value) {
          objeto[prop] = value[prop];
        }
        resultado.push(objeto);
      });
      return resultado;
    },
  },
};
</script>
